import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import ProblemesCoffre from "./components/ProblemesCoffre";
import AccesCoffre from "./components/AccesCoffre";
import ReparationPieces from "./components/ReparationPieces";
import ReparerPlutot from "./components/ReparerPlutot";
import CTAAppel from "./components/CTAAppel";
import FAQ from "./components/FAQ";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function CoffreVoletRoulant() {
  return (
    <main>
      <SEOHead
        title="Coffre Volet Roulant Strasbourg | R&eacute;paration M&eacute;canisme"
        description="R&eacute;paration de coffre et m&eacute;canisme de volet roulant &agrave; Strasbourg et dans le Bas-Rhin. Toutes marques, devis gratuit. 03 74 47 32 40."
        path="/coffre-volet-roulant"
        type="service"
        serviceType="R&eacute;paration de coffre de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Coffre volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Coffre volet roulant" }]} />
      <Hero />
      <DiagnosticVideo />
      <Reassurances />
      <ProblemesCoffre />
      <AccesCoffre />
      <ReparationPieces />
      <ReparerPlutot />
      <CTAAppel />
      <FAQ />
      <Galerie />
      <Maillage />
      <Formulaire />
      <CTAAppel />
      <Avis />
      <Footer />
      <FloatingButton />
    </main>
  );
}